import * as types from "./organizationType";

const initialState = {
  fetchListOrganizations: {
    loading: false,
    data: [],
    error: null,
  },
  currentOrganization: {
    loading: false,
    data: null,
    error: null,
  },
  addOrganization: {
    loading: false,
    success: false,
    error: null,
  },
  updateOrganization: {
    loading: false,
    success: false,
    error: null,
  },
  deleteOrganization: {
    loading: false,
    success: false,
    error: null,
  },
};

const organizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LIST_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        fetchListOrganizations: { ...state.fetchListOrganizations, loading: true },
      };
    case types.FETCH_LIST_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        fetchListOrganizations: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case types.FETCH_LIST_ORGANIZATIONS_FAILURE:
      return {
        ...state,
        fetchListOrganizations: {
          ...state.fetchListOrganizations,
          loading: false,
          error: action.payload,
        },
      };

    case types.FETCH_ORGANIZATION_REQUEST:
      return {
        ...state,
        currentOrganization: { ...state.currentOrganization, loading: true },
      };
    case types.FETCH_ORGANIZATION_SUCCESS:
      return {
        ...state,
        currentOrganization: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case types.FETCH_ORGANIZATION_FAILURE:
      return {
        ...state,
        currentOrganization: {
          ...state.currentOrganization,
          loading: false,
          error: action.payload,
        },
      };

    case types.ADD_ORGANIZATION_REQUEST:
      return {
        ...state,
        addOrganization: { ...state.addOrganization, loading: true, success: false },
      };
    case types.ADD_ORGANIZATION_SUCCESS:
      return {
        ...state,
        addOrganization: { loading: false, success: true, error: null },
      };
    case types.ADD_ORGANIZATION_FAILURE:
      return {
        ...state,
        addOrganization: { loading: false, success: false, error: action.payload },
      };

    case types.UPDATE_ORGANIZATION_REQUEST:
      return {
        ...state,
        updateOrganization: { ...state.updateOrganization, loading: true, success: false },
      };
    case types.UPDATE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        updateOrganization: { loading: false, success: true, error: null },
      };
    case types.UPDATE_ORGANIZATION_FAILURE:
      return {
        ...state,
        updateOrganization: { loading: false, success: false, error: action.payload },
      };

    case types.DELETE_ORGANIZATION_REQUEST:
      return {
        ...state,
        deleteOrganization: { ...state.deleteOrganization, loading: true, success: false },
      };
    case types.DELETE_ORGANIZATION_SUCCESS:
      return {
        ...state,
        deleteOrganization: { loading: false, success: true, error: null },
      };
    case types.DELETE_ORGANIZATION_FAILURE:
      return {
        ...state,
        deleteOrganization: { loading: false, success: false, error: action.payload },
      };

    case types.RESET_CURRENT_ORGANIZATION:
      return {
        ...state,
        currentOrganization: initialState.currentOrganization,
        addOrganization: initialState.addOrganization,
        updateOrganization: initialState.updateOrganization,
      };

    default:
      return state;
  }
};

export default organizationReducer;
